import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-12 items-stretch" }
const _hoisted_2 = { class: "flex gap-5 items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "flex-grow mt-0" }, "Profile", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Display Name:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Email:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Display Colour:", -1)
const _hoisted_7 = { class: "rounded-mention p-12 border border-warm bg-warm self-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Danger Zone:", -1)
const _hoisted_9 = {
  key: 0,
  class: "border-b border-charcoal-ghost mention"
}
const _hoisted_10 = {
  key: 1,
  class: "flex gap-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "btn-danger-outline rounded-mention mention p-mention flex items-center",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, " Logout "),
      _createVNode(_component_Icon, {
        icon: ['fal', 'times'],
        class: "icon-base p-mention clickable",
        onClick: _ctx.closeHelper
      }, null, 8, ["onClick"])
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
      class: "mention rounded-mention p-cell border border-warm bg-warm cursor-default text-charcoal-ghost",
      placeholder: "Display Name",
      readonly: "",
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveName && _ctx.saveName(...args)))
    }, null, 544), [
      [_vModelText, _ctx.username]
    ]),
    _hoisted_5,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.useremail) = $event)),
      class: "mention rounded-mention p-cell border border-warm bg-warm cursor-default text-charcoal-ghost",
      placeholder: "Display Name",
      readonly: ""
    }, null, 512), [
      [_vModelText, _ctx.useremail]
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        style: { width: '40px', height: '40px' },
        class: _normalizeClass(["flex items-center justify-center rounded-mention", `bg-pallet-${_ctx.displayColor} border border-charcoal`])
      }, null, 2)
    ]),
    _hoisted_8,
    _createElementVNode("div", {
      class: "p-cell btn-danger-outline rounded-mention",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.warning = true))
    }, " Delete Account "),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Are you sure? "))
      : _createCommentVNode("", true),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "p-cell btn-fine-outline rounded-mention flex-1 font-semibold",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.warning = false))
          }, " No "),
          _createElementVNode("div", {
            class: "p-cell btn-danger-outline rounded-mention flex-1 font-semibold",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteAccount && _ctx.deleteAccount(...args)))
          }, " Yes, Delete ")
        ]))
      : _createCommentVNode("", true)
  ]))
}